import { colors } from '../../theme';

const S = {
    dialogPaperPropsSX: {
        minWidth: 500,
        minHeight: 445,
        backgroundColor: colors.darkBlue
    },
    modalTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: '"Inter",sans-serif',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '19px',
        marginTop: '25px',
        marginLeft: '10px',
        color: colors.white90
    },
    modalContent: {
        marginTop: '18px'
    },
    closeIconButton: {
        color: colors.white90
    }
};

export default S;
